import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import ApiService from '../../../../services/api'
import queryString from 'query-string';
import TableModal from '@/components/TableModal';
import { useMembers } from '@/hooks/useApi';
import { tableColumnsMember,renderActionMember, columnsLoan, scheduleColumns } from './column'
import { Grid } from 'gridjs-react';
import { _ } from "gridjs-react";
import LoanModal from '@/components/LoanModal';
import LoanPaymentModal from '@/components/LoanPaymentModal';

const LoansPayment = () => {
  const params = queryString.parse(window.location.search);
  const id = params.id || null
  const loansId = params.loansId || null
  const navigate = useNavigate();
  const [member, setMember] = useState([]);
  const [loan, setLoan] = useState({});
  const [loanTable, setLoanTable] = useState([]);
  const [loans, setLoans] = useState([]);
  const [schedule, setSchedule] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isOpenMember, setIsOpenMember] = useState(false);
  const [isOpenLoan, setIsOpenLoan] = useState(false);
  const [isOpenPayment, setIsOpenPayment] = useState(false)

  const { data: membersData } = useMembers();
  const members = membersData?.data || [];

  useEffect(() => {
    setLoading(true)
    setIsOpenLoan(false)
    if (id) {
      fetchLoansByMember()
    }
    
    if(id && loansId === null){
      setIsOpenLoan(true)
    }
    
    if (id && loansId) {
      setIsOpenLoan(false)
      fetchLoanById(loansId)
      fetchMemberDetail();
      fetchSchedule();
    }
    
    setLoading(false);
  }, [id,loansId]);
  
  const fetchLoanById = async (id) => {
    try {
      setLoading(true);
      const response = await ApiService.get(`/loans/${id}`);
      setLoan(response.data || {});
      setLoanTable([response.data] || [])
    } catch (error) {
      if (error.status !== 403) {
        console.error('Error fetching schedule:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error!',
          text: 'Failed to load schedule'
        });
      }
      setLoan([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchSchedule = async () => {
    try {
      setLoading(true);
      const response = await ApiService.get(`/loans/${loansId}/schedules`);
      setSchedule(response.data || []);
    } catch (error) {
      if (error.status !== 403) {
        console.error('Error fetching schedule:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error!',
          text: 'Failed to load schedule'
        });
      }
      setSchedule([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchMemberDetail = async () => {
    try {
      setLoading(true);
      const response = await ApiService.get(`/members/${id}`);
      setMember([response.data] || []);
    } catch (error) {
      console.error('Error fetching member detail:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error!',
        text: 'Failed to load member details'
      });
    } finally {
      setLoading(false);
    }
  };
  
  const fetchLoansByMember = async () => {
    try {
      const response = await ApiService.get(`/members/${id}/loans`);
      setLoans(response.data || []);
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error!',
        text: error || 'Failed to load loans data'
      });
    }
  }
  
  const getStatusBadge = (status) => {
    const badges = {
      true: 'bg-green-100 text-green-800 border-green-300',
      false: 'bg-red-100 text-red-800 border-red-300',
    };
    return badges[status] || 'bg-gray-100 text-gray-800 border-gray-300';
  };

  const handleFormSubmit = async (form) => {
    try {
      const updatedForm = {
        ...form,
        payment_method_id: Number(form.payment_method_id)
      }
      const response = await ApiService.post(`/loans/admin/flexible-payment`, updatedForm);
      if (response.status === 200) {
        Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: 'Pembayaran Pinjaman success'
        }).then(() => {
          fetchSchedule()
        });
      } else {
        throw new Error(response.message || 'Pembayaran Pinjaman Failed!');
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error!',
        text: error || 'Pembayaran Pinjaman Failed!'
      });
    }
  }

  const columnMember = [
    {
      name: 'Kode Anggota',
      data: (row) => row.member.member_id_number,
    },
    {
      name: 'Nama Anggota',
      data: (row) => row.member.full_name
    },
    {
      name: 'Jenis Pinjaman',
      data: (row) => row.loan_product.name,
    },
    {
      name: 'Kontak',
      data: (row) => row.member.phone_number, 
    },
    {
      name: 'Status',
      data: (row) => row,
      formatter: (cell) => {
        return _(
          <span className={`text-gray-900 px-3 whitespace-nowrap py-1 text-sm font-semibold rounded-md border ${getStatusBadge(cell.total_paid === cell.term_months)}`}>{cell.total_paid === cell.term_months ? 'Lunas' : 'Belum Lunas'}</span>
        );
      }
    },
    {
      name: 'Info',
      data: (row) => row,
      formatter: (row) => {
        const handlePayment = () => {
          setIsOpenPayment(true)
        }

        return _(
          <>
            <div className="flex flex-col w-[30px] gap-3 xl:w-48">
              <button
                className="inline-flex items-center justify-center px-4 py-3 border border-gray-300 rounded-lg shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
                onClick={() => handlePayment()}
              >
                Bayar Cicilan
              </button>
              <button 
                onClick={() => console.log('bayar')}
                className="inline-flex whitespace-nowrap items-center justify-center px-4 py-3 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-colors"
                disabled
              >
                Pelunasan
              </button>
            </div>
          </>
        )
      }
    }
  ]

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
        <span className="ml-2 text-gray-600">Loading member details...</span>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      {/* Breadcrumb */}
      <nav className="flex mb-6" aria-label="Breadcrumb">
        <ol className="inline-flex items-center space-x-1 md:space-x-3">
          <li className="inline-flex items-center">
            <Link 
              to="/dashboard"
              className="inline-flex items-center text-sm font-medium text-gray-700 hover:text-blue-600"
            >
              <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"></path>
              </svg>
              Dashboard
            </Link>
          </li>
          <li>
            <div className="flex items-center">
              <svg className="w-6 h-6 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd"></path>
              </svg>
              <button
                onClick={() => navigate('/admin/loans-payment')}
                className="ml-1 text-sm font-medium text-gray-700 hover:text-blue-600 md:ml-2"
              >
                Loans Payment
              </button>
            </div>
          </li>
          {member && (
            <li aria-current="page">
                <div className="flex items-center">
                    <svg className="w-6 h-6 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd"></path>
                    </svg>
                    <span className="ml-1 text-sm font-medium text-gray-500 md:ml-2 truncate max-w-xs">
                        {member.full_name}
                    </span>
                </div>
            </li>
          )}
        </ol>
      </nav>

      {/* Header */}
      <div className="rounded-lg shadow-sm p-8 mb-6">
        <div className="flex flex-col xl:flex-row xl:items-start xl:justify-between gap-6">
          <div className="flex-1">
            <div className="flex items-start space-x-6">

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-4 mb-3">
                  <h1 className="text-3xl font-bold text-gray-900 truncate">
                    Pembayaran Pinjaman 
                  </h1>
                </div>
                
                <div className="flex items-center mb-4">
                  <svg className="w-5 h-5 mr-2 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-4 0v1h4v-1" />
                  </svg>
                  <span className="text-lg font-medium text-gray-700">Pembayaran Pinjaman </span>
                </div>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row xl:flex-col gap-3 xl:w-48">
            <button 
              onClick={() => setIsOpenMember(true)}
              className="inline-flex items-center justify-center px-4 py-3 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
            >
              <i className='mgc_book_line mr-3'></i>
              Data Anggota
            </button>
          </div>
        </div>
      </div>
      
      {/* Main Content */}
      <>
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 mb-6">
            <div className="flex flex-col xl:flex-row xl:items-start xl:justify-between gap-6">
              {/* Left Section - Member Info */}
              <div className="flex-1">
                  <div className="flex items-start space-x-6">
                  {/* Member Avatar/Photo */}
                    <div className="flex-shrink-0">
                      {member?.id_file_url ? (
                          <img 
                              src={member?.id_file_url}
                              alt={member?.full_name}
                              className="w-20 h-20 rounded-full object-cover border-4 border-gray-100 shadow-sm"
                              onError={(e) => {
                              e.target.style.display = 'none';
                              e.target.nextElementSibling.style.display = 'flex';
                              }}
                          />
                          ) : (
                          <div className="w-20 h-20 rounded-full bg-gray-100 flex items-center justify-center border-4 border-gray-200 shadow-sm">
                              <svg className="w-10 h-10 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                              <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd"></path>
                              </svg>
                          </div>
                      )}
                      <div className="w-20 h-20 rounded-full bg-gray-100 items-center justify-center border-4 border-gray-200 shadow-sm" style={{ display: 'none' }}>
                          <svg className="w-10 h-10 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                              <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd"></path>
                          </svg>
                      </div>
                    </div>
                    <div className='flex-1'>
                      <Grid
                        data={loanTable}
                        columns={columnMember}
                        pagination={false}
                        search={false}
                        sort={false}
                      />
                    </div>
                  </div>
              </div>
            </div>
        </div>
      </>
      <div className="grid grid-cols-1 gap-8">
        {/* Main Information */}
        <div className="lg:col-span-2 space-y-6">
        {/* Table Schedule */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">Data Angsuran</h2>
            <div className="grid grid-cols-1 md:grid-cols-1 gap-6">
              <div className="overflow-x-auto">
                <Grid
                  data={schedule}
                  columns={scheduleColumns}
                  pagination={{ enabled: true, limit: 10 }}
                  search={false}
                  sort={true}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <LoanModal 
        isOpen={isOpenLoan}
        onClose={() => setIsOpenLoan(false)}
        columns={columnsLoan(id,navigate)}
        data={loans}
        action={renderActionMember}
        title="Pilih Jenis Pinjaman"
      />

      <LoanPaymentModal
        isOpen={isOpenPayment}
        onClose={() => setIsOpenPayment(false)}
        onSubmit={handleFormSubmit}
        title={`Pembayaran ${loan?.loan_product?.name}`}
        dataLoan={loan}
        schedule={schedule}
      />

      <TableModal 
        isOpen={isOpenMember}
        onClose={() => setIsOpenMember(!isOpenMember)}
        columns={tableColumnsMember}
        data={members}
        action={renderActionMember}
        title="Data Anggota"
        navigate={navigate}
      />
    </div>
  );
};

export default LoansPayment;
